module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty13.c5f67767.jpg";